<script setup lang="ts">
import TopHeader from '~/components/TopHeader.vue'

const props = defineProps({
  error: Object,
})

const handleBack = () => window.history.go(-1)
</script>

<template>
  <!-- 顶部导航 -->
  <TopHeader title="页面出错了" />
  <div class="error-wrap">
    <div class="tip-img">
      <img src="https://imgf1.fccs.com.cn/small-programe/v2/images/nonet.png" alt="页面出错">
    </div>
    <h1 v-if="error.statusCode === 404" class="code">
      {{ error.statusMessage }}
    </h1>
    <h1 v-else class="code">
      An error occurred
    </h1>
    <div class="nav">
      <span @click="handleBack">返回上一页</span>
      <a href="/">
        返回首页
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-wrap {
  .code {
    font-size: 50px;
    text-align: center;
    padding-top: 80px;
  }
  .nav {
    text-align: center;
    padding-top: 30px;
    color: $c1;
    a{
      color: $c1;
    }
  }
  .tip-img {
    padding:200px 100px 0;
    img {
      max-width: 100%;
    }
  }
}
</style>
